/**
 * Two concerns:
 *   1. AJAX-style filter form: auto-submit on checkbox / sort change with a
 *      short debounce (full-page navigation — fast, reliable, shareable URLs).
 *   2. Mobile filter drawer: open/close + body scroll lock.
 *
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initFilterForm();
    initMobileDrawer();
  });

  // ── 1. Filter form auto-submit ──
  function initFilterForm() {
    const form = document.querySelector('[data-psr-filter-form]');
    if (!form) return;

    let debounceTimer = null;
    function debouncedSubmit() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { form.submit(); }, 250);
    }

    form.querySelectorAll('[data-psr-filter-input]').forEach(function (input) {
      input.addEventListener('change', debouncedSubmit);
    });

    // Sort select lives outside <form> but uses form="..." attr — change submits immediately
    const sortSelect = document.querySelector('[data-psr-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        // Mirror selection into the hidden sort input inside the form so the
        // submitted query string contains the sort value even if the browser
        // does not include the form="" select in the GET payload.
        const hiddenSort = form.querySelector('[data-psr-sort-hidden]');
        if (hiddenSort) hiddenSort.value = sortSelect.value;
        form.submit();
      });
    }

    const priceApply = form.querySelector('[data-psr-price-apply]');
    if (priceApply) {
      priceApply.addEventListener('click', function () { form.submit(); });
    }

    // Submit on Enter inside a price input
    form.querySelectorAll('[data-psr-price-input]').forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          form.submit();
        }
      });
    });
  }

  // ── 2. Mobile drawer ──
  function initMobileDrawer() {
    const openBtn = document.querySelector('[data-psr-mobile-filter-btn]');
    const sidebar = document.querySelector('[data-psr-sidebar]');
    const closeBtn = document.querySelector('[data-psr-mobile-close]');
    const applyBtn = document.querySelector('[data-psr-mobile-apply]');
    const backdrop = document.querySelector('[data-psr-mobile-backdrop]');
    const form = document.querySelector('[data-psr-filter-form]');
    if (!openBtn || !sidebar) return;

    function open() {
      sidebar.classList.add('is-open');
      if (backdrop) {
        backdrop.hidden = false;
        // Force reflow so the opacity transition fires
        void backdrop.offsetWidth;
        backdrop.classList.add('is-open');
      }
      document.body.classList.add('psr-drawer-open');
      openBtn.setAttribute('aria-expanded', 'true');
    }

    function close() {
      sidebar.classList.remove('is-open');
      if (backdrop) {
        backdrop.classList.remove('is-open');
        // Hide after transition so it doesn't trap clicks
        setTimeout(function () { backdrop.hidden = true; }, 300);
      }
      document.body.classList.remove('psr-drawer-open');
      openBtn.setAttribute('aria-expanded', 'false');
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);

    if (applyBtn && form) {
      applyBtn.addEventListener('click', function () {
        form.submit();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
        close();
      }
    });
  }
})();
